import { render, staticRenderFns } from "./VehicleStatus.vue?vue&type=template&id=2be90a7e"
import script from "./VehicleStatus.vue?vue&type=script&lang=js"
export * from "./VehicleStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports